module.exports = __webpack_public_path__ + "static/media/app-store-rejects.773a170e.jpg";